/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospectintake_SubmitProspectIntakeRequest = {
    /**
     * ChildDateOfBirth accepts a FUTURE date on purpose: a family may enquire
     * during a pregnancy.
     */
    child_date_of_birth?: string;
    child_first_name?: string;
    child_last_name?: string;
    desired_care_days_per_week?: number;
    desired_childcare_ids: Array<string>;
    desired_start_date?: string;
    /**
     * Locale is the family's language. It is stored verbatim as the prospect's
     * language_correspondence and shown on the prospect detail page. All six codes
     * are kept as submitted -- contacts.language_correspondence offers only en and
     * de, but narrowing here would discard what the family told us.
     */
    locale?: prospectintake_SubmitProspectIntakeRequest.locale;
    message?: string;
    parent_email?: string;
    parent_first_name: string;
    parent_last_name: string;
    parent_phone?: string;
    /**
     * Website is the HONEYPOT. A real family never sees it; a bot fills it. When
     * it arrives non-empty the endpoint answers 202 with an empty body and writes
     * nothing.
     */
    website?: string;
};
export namespace prospectintake_SubmitProspectIntakeRequest {
    /**
     * Locale is the family's language. It is stored verbatim as the prospect's
     * language_correspondence and shown on the prospect detail page. All six codes
     * are kept as submitted -- contacts.language_correspondence offers only en and
     * de, but narrowing here would discard what the family told us.
     */
    export enum locale {
        DE = 'de',
        EN = 'en',
        ES = 'es',
        FR = 'fr',
        IT = 'it',
        PT = 'pt',
    }
}

